<template>
<div class="row justify-content-md-center">

	<div class="col-12 col-xl-8">

		<div class="row">
			<div class="col">

                <b-form-group class="pull-right">
					<b-btn variant="outline-secondary"
					       v-b-tooltip.hover
					       title="Terug"
					       exact
					       :to="{ name: 'personList' }">
						<i class="fa fa-fw fa-reply"></i>
					</b-btn>
				</b-form-group>

				<h1 class="display-4">{{ $t('person.import') }}</h1>
			</div>
		</div>

        <partial-loader :loading="isImporting" />

        <div class="row" v-if="!isImporting">
            <div class="col-12 col-xl-6">
                <b-form @submit.prevent="uploadFile()" class="mb-3">
                    <b-form-group :label="$t('person.uploadNextlotFile') + ':'">
                        <b-form-file
                            ref="fileinput"
                            v-model="file"
                            :placeholder="$t('common.chooseFile')"
                        >
                        </b-form-file>
                    </b-form-group>

                    <b-button
                        type="submit"
					    variant="primary"
                    >
                        <i class="fa fa-fw fa-save"></i> {{ $t('common.upload') }}
                    </b-button>
                </b-form>
            </div>
        </div>

        <div class="row">

            <div class="col-12">
                <b-alert variant="success" :show="successfullImported > 0">
                    {{ $t('person.importSuccessPersons', { personCount: successfullImported, personCountNew: newImported }) }}
                </b-alert>

                <b-alert variant="warning" :show="!isNil(errors)">
                    <error-list :errors="errors"></error-list>
                </b-alert>
            </div>

            <div class="col-12">
                <b-table v-show="usersWithErrors.length > 0" hover :items="usersWithErrors" :fields="tableFields" caption-top  >

                    <template slot="table-caption">
                        {{ $t('person.importFailedPersons') }}:
                    </template>

                    <template v-slot:cell(fixedBidNumber)="row">{{row.item.user.fixed_bid_number}}</template>
                    <template v-slot:cell(email)="row">{{row.item.user.email}}</template>
                    <template v-slot:cell(name)="row">{{row.item.user.first_name}} {{row.item.user.last_name}}</template>
                    <template v-slot:cell(errors)="row">
                        <error-list :errors="row.item.errors"></error-list>
                    </template>
                </b-table>
            </div>
        </div>
	</div>
</div>
</template>
<script>

import { isNil } from 'lodash';
import ImportService from '@/services/import-service';
import ErrorList from '@/components/elements/ErrorList';
import PartialLoader from '@/components/elements/PartialLoader';

export default {
    components: {
        ErrorList,
        PartialLoader
    },
	data() {
        return {
            file: null,
            isImporting: false,
            usersWithErrors: [],
            successfullImported: null,
            newImported: null,
            errors: null,
            tableFields: [
                {
                    key: 'fixedBidNumber',
                    label: this.$t('person.fixedBidNumber'),
                },
                {
                    key: 'email',
                    label: this.$t('common.email'),
                },
                {
                    key: 'name',
                    label: this.$t('common.name'),
                },
                {
                    key: 'errors',
                    label: this.$t('common.errors'),
                    variant: 'danger',
                },
            ]
        }
    },
    methods: {
        isNil: isNil,
        reset() {
            this.isImporting = false;
            this.usersWithErrors = [];
            this.successfullImported = null;
            this.newImported = null;
            this.errors = null;
        },
        uploadFile() {
            this.reset();
            this.isImporting = true;

            const fileList = new FormData();
            fileList.append('nextlot', this.file);

            ImportService.importNextlot(fileList)
                .then(next => {
                    this.successfullImported = next.successfull_imported;
                    this.newImported = next.new_imported;
                    this.usersWithErrors = next.users_with_errors;
                    this.isImporting = false;
                    this.clearFiles();                    
                })
                .catch(error => {
                    if(error.response && error.response.data.errors)
                        this.errors = error.response.data.errors;

                    this.isImporting = false;
                });
        },
        clearFiles () {
            this.$refs.fileinput.reset();
        }
    }
}
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// PersonImport.vue?22418e36